import React, { FC, PropsWithChildren, ReactNode, useEffect } from 'react';
import { Link } from 'react-router-dom';
import '@/styles/sunday-table.css';
import { LoadingLayout } from '@/shared/components/loading-layout';

export interface GuestShellProps {
  title: string;
  right?: ReactNode;
  wide?: boolean;
  className?: string;
}

export const Brand: FC = () => (
  <Link to="/" className="st-brand" aria-label="Bhabi home">
    Bhabi
    <span className="st-brand__pip" aria-hidden="true">
      ♠
    </span>
  </Link>
);

/** Full-bleed felt page with safe-area padding, brand and an optional action. */
export const GuestShell: FC<PropsWithChildren<GuestShellProps>> = ({
  title,
  right,
  wide,
  className = '',
  children,
}) => {
  useEffect(() => {
    document.title = `${title} · Bhabi`;
  }, [title]);

  return (
    <div className={`st-app ${className}`}>
      <div className={`st-container ${wide ? 'st-container--wide' : ''}`}>
        <header className="st-topbar">
          <Brand />
          {right}
        </header>
        <main id="main">{children}</main>
      </div>
    </div>
  );
};

export const LoadingState: FC<{ label: string }> = ({ label }) => (
  <LoadingLayout inline text={label} />
);
